import { useNavigate } from "react-router-dom";
import {
  ArrowRightLeft,
  BookOpen,
  ClipboardList,
  Coins,
  FlaskConical,
  Package,
  Users,
  Warehouse,
} from "lucide-react";

import { useProfileStore } from "~/store/profileStore";

// Consumption/recipe cards (available to producción too); the rest are the
// logística client-goods ledger, shown only to logística/bodega/admins.
const consumptionSections = [
  {
    title: "Registrar Consumo",
    description:
      "Rebaja insumos de Aliace entregados al cliente según lo producido",
    icon: FlaskConical,
    url: "/maquila/consumptions/new",
    color: "bg-indigo-50 text-indigo-600 border-indigo-200",
  },
  {
    title: "Consumos de Maquila",
    description: "Historial y costo de los insumos consumidos",
    icon: Coins,
    url: "/maquila/consumptions",
    color: "bg-rose-50 text-rose-600 border-rose-200",
  },
  {
    title: "Recetas de Maquila",
    description: "Insumos que consume cada producto del cliente",
    icon: BookOpen,
    url: "/maquila/recipes",
    color: "bg-cyan-50 text-cyan-600 border-cyan-200",
  },
];

const ledgerSections = [
  {
    title: "Inventario",
    description:
      "Ver stock actual por area: Insumos, Materia Prima, Producto Terminado",
    icon: Warehouse,
    url: "/maquila/inventory",
    color: "bg-emerald-50 text-emerald-600 border-emerald-200",
  },
  {
    title: "Registrar Movimiento",
    description: "Entrada, salida o transferencia de materiales",
    icon: ArrowRightLeft,
    url: "/maquila/movements/new",
    color: "bg-blue-50 text-blue-600 border-blue-200",
  },
  {
    title: "Historial de Movimientos",
    description: "Ver todos los movimientos registrados",
    icon: ClipboardList,
    url: "/maquila/movements",
    color: "bg-amber-50 text-amber-600 border-amber-200",
  },
  {
    title: "Materiales",
    description: "Gestionar materiales/productos de clientes",
    icon: Package,
    url: "/maquila/items",
    color: "bg-slate-50 text-slate-600 border-slate-200",
  },
  {
    title: "Clientes Maquila",
    description: "Gestionar clientes del servicio de maquila",
    icon: Users,
    url: "/maquila/clients",
    color: "bg-purple-50 text-purple-600 border-purple-200",
  },
];

export const MaquilaLandingPage = () => {
  const navigate = useNavigate();
  const { role } = useProfileStore();

  // Producción only needs the consumption/recipe tools; logística/bodega/admins
  // also manage the client-goods ledger.
  const isProductionOnly = role === "production" || role === "produccion-admin";
  const sections = isProductionOnly
    ? consumptionSections
    : [...consumptionSections, ...ledgerSections];

  return (
    <div className="mx-auto max-w-5xl p-6">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Bodega Maquila</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Gestiona materiales de clientes para procesamiento (maquila) y registra
          el consumo de insumos de Aliace entregados a los clientes.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {sections.map((section) => {
          const Icon = section.icon;
          return (
            <button
              key={section.url}
              onClick={() => navigate(section.url)}
              className={`flex flex-col items-start gap-3 rounded-xl border p-5 text-left transition-all hover:-translate-y-0.5 hover:shadow-md active:translate-y-0 ${section.color}`}
            >
              <Icon className="h-7 w-7" />
              <div>
                <h3 className="text-sm font-semibold">{section.title}</h3>
                <p className="mt-1 text-xs leading-relaxed opacity-70">
                  {section.description}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
